import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { ThirdPartiesCmp_SomePeople_QueryDocument } from '../queries/some-people.query';

export const useFindAllDeletedInternalPeopleQuery = (enabled = true) => {
  const { genericStatusesCodeMap } = useReferencesContext();

  return useGraphQLQuery(
    ThirdPartiesCmp_SomePeople_QueryDocument,
    {
      statusId: genericStatusesCodeMap.Deleted._id,
      isInternal: true,
    } as const,
    { enabled },
  );
};
